import React from 'react';
import {
  Dialog,
  ButtonStandard,
  ButtonLight,
  Label,
  MobileLayoutHOC,
  ScreenMessagePanelContainer
} from 'cw-ui-core';
import Locale from 'src/Locale';
import WithButtonLoadingIndicatorHOC from 'src/components/HoC/WithButtonLoadingIndicatorHOC';
import css from 'src/components/HomePage/ToolsPod/Resources/ResourcesDialogs/AddEditResourceDialog.scss';

export const ADD_EDIT_CONFIRM_RESOURCE_DIALOG =
  'ADD_EDIT_CONFIRM_RESOURCE_DIALOG';

const AddEditConfirmResourceDialog = props => {
  const {
    intl: { formatMessage },
    isMobileLayout,
    onCloseDialog,
    onSaveClick,
    isSaving,
    isEdit
  } = props;

  const SaveAndCancelButton = () => {
    const button = () => (
      <ButtonStandard
        automationName="saveResourceButton"
        value={formatMessage(Locale.confirm)}
        isSmall
        onClick={onSaveClick}
      />
    );
    const LoadingButton = WithButtonLoadingIndicatorHOC(button);
    return [
      <ButtonLight
        automationName="cancelDialogButton"
        key="buttonCancel"
        value={formatMessage(Locale.cancel)}
        isSmall
        onClick={onCloseDialog}
      />,
      <LoadingButton
        key="buttonConfirm"
        isBusy={isSaving}
        wrapperStyle={{ height: '36px', width: '78px' }}
      />
    ];
  };

  return (
    <Dialog
      automationName="confirmSaveResourceDialog"
      buttons={SaveAndCancelButton()}
      includeCloseIcon={!isMobileLayout}
      includeMobileCloseIcon={isMobileLayout}
      onCloseIconClicked={onCloseDialog}
    >
      <ScreenMessagePanelContainer
        screenKey={ADD_EDIT_CONFIRM_RESOURCE_DIALOG}
        className={isMobileLayout ? css.screenMessageMobile : css.screenMessage}
      />
      <Label
        className={css.headerTitle}
        value={
          isEdit
            ? formatMessage(Locale.confirm_edit_resource_header_text)
            : formatMessage(Locale.confirm_add_resource_header_text)
        }
      />

      <Label
        className={
          isMobileLayout ? css.contentMessageMobile : css.contentMessageFull
        }
        value={
          isEdit
            ? formatMessage(Locale.confirm_edit_resource_text)
            : formatMessage(Locale.confirm_add_resource_text)
        }
      />
    </Dialog>
  );
};

export default MobileLayoutHOC(AddEditConfirmResourceDialog);
